<template>
    <div id="app">
        <v-app id="inspire">
            <v-card v-model="show" color="#FFFF99">
                <v-card-title>
                    <h6>Listado de Indicadores y Objetivos Parciales</h6>
                </v-card-title>

            </v-card>
            <v-data-table dense :headers="headers" :items="listado" locale="es-ar" :items-per-page="4000"
                hide-default-footer :loading="loadtable" loading-text="Cargando... Espere por favor"
                no-data-text="No hay datos disponibles">
                <template v-slot:item.veri="{ item }">
                    <v-icon small color="blue" class="mr-2" @click.stop="verIndic(item)">
                        mdi-eye
                    </v-icon>
                </template>
                <template v-slot:item.vero="{ item }">
                    <v-icon small color="green" class="mr-2" @click.stop="verObjet(item)">
                        mdi-eye
                    </v-icon>
                </template>
            </v-data-table>
            <VerIndic :visible="showverindic" :fecha="editedItem.fecha" @close="showverindic = false"></VerIndic>
            <VerObjet :visible="showverobjet" :fecha="editedItem.fecha" @close="showverobjet = false">
            </VerObjet>
        </v-app>
    </div>
</template>
<style scoped>
.tabla-limitada {
    max-width: 1200;
    /* 👈 ancho máximo */
    margin: 0 auto;
    /* opcional: centrar la tabla */
}

.font-class-name2 {
    font-size: 12px !important;
}

::v-deep .v-data-table .v-data-table__wrapper td {
    font-size: 12px !important;
    padding: 2px 4px !important;
}

::v-deep .v-data-table .v-data-table-header tr th {
    font-size: 12px !important;
    padding: 2px 4px !important;
}
</style>
<script>
import axios from "../../axios-auth.js";
import VerIndic from "../Indicadores/Tablero.vue";
import VerObjet from "../Objetivos/Listadoparciales.vue";
import moment from "moment";
export default {
    components: { VerIndic, VerObjet },
    data: (vm) => ({
        editedItem: {},
        editedIndex: -1,
        listado: [],
        showverindic: false,
        showverobjet: false,
        loadtable: false,
        headers: [
            {
                text: "Año",
                align: "center",
                sortable: false,
                value: "anio",
            },
            { text: "Fecha", value: "fecha", align: "center", sortable: false },
            { text: "Tablero indicadores / objetivos", align: "center", value: "veri", sortable: false },
            { text: "Listado EI100", value: "vero", align: "center", sortable: false },
        ],
    }),
    computed: {
        show: {
            get() {
                this.cargarListado();
                return this.visible;
            },
            set(value) {
                if (!value) {
                    this.$emit("close");
                }
            },
        },
    },

    methods: {
        verIndic(item) {
            this.editedIndex = this.listado.indexOf(item);
            this.editedItem = Object.assign({}, item);
            this.showverindic = true;
        },
        verObjet(item) {
            this.editedIndex = this.listado.indexOf(item);
            this.editedItem = Object.assign({}, item);
            this.showverobjet = true;
        },
        cargarListado() {
            this.loadtable = true;
            let self = this;
            axios
                .get("/Indicadores/ListadoParciales?", {

                })
                .then((response) => {
                    self.listado = response.data;
                    self.loadtable = false;
                })
                .catch((error) => {
                    self.listado = [];
                    console.log(error);
                });
        },
    },
};
</script>